import React from 'react';
import PropTypes from 'prop-types';
import CardChip from '../CardChip';
import { getIsActive, getIsExpiring, getIsNew } from '@general/helpers/propertyStatus.helpers';

export const PropertyChip = ({ activatedAt, expiresAt, activations }) => (
    <>
        {getIsExpiring(expiresAt) && (
            <CardChip className="mr-2" color="yellow">
                Expiring Soon
            </CardChip>
        )}

        {!getIsActive(activatedAt) && (
            <CardChip className="mr-2" color="yellow">
                Inactive
            </CardChip>
        )}

        {getIsNew({ activatedAt, activations }) && <CardChip className="mr-2">New Property</CardChip>}
    </>
);

PropertyChip.propTypes = {
    activatedAt: PropTypes.string,
    expiresAt: PropTypes.string,
    activations: PropTypes.number,
};
